import { all, fork } from 'redux-saga/effects';

import BlogSaga from './ui/blog/sagas';
import blogGetAllSagas from './blog/get-all/sagas';
import homeSagas from './ui/home/sagas';
import mediaGetAllSagas from './media/get-all/sagas';
import navigation from './navigation/sagas';
import questionSagas from './ui/questions/sagas';
import questionsCategoryOptions from './questions/category-options/sagas';
import questionsGetAllSagas from './questions/get-all/sagas';
import responsesGetAllSagas from './responses/get-all/sagas';
import resultsSagas from './ui/results/sagas';

export default function* root() {
  yield all([
    fork(BlogSaga),
    fork(blogGetAllSagas),
    fork(homeSagas),
    fork(mediaGetAllSagas),
    fork(navigation),
    fork(questionSagas),
    fork(questionsCategoryOptions),
    fork(questionsGetAllSagas),
    fork(responsesGetAllSagas),
    fork(resultsSagas),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js